import {
  Button,
  EmptyState,
  PlusIcon,
  TagIcon,
  useIsMobileScreenSize,
} from '@buffer-mono/popcorn'

import styles from '../Tags.module.css'

import type { JSX } from 'react'

interface TagsEmptyStateProps {
  canManageTags: boolean
  hasCreatePermission: boolean
  onCreateClick: () => void
}

export const TagsEmptyState = ({
  canManageTags,
  hasCreatePermission,
  onCreateClick,
}: TagsEmptyStateProps): JSX.Element => {
  const isMobile = useIsMobileScreenSize()

  return (
    <EmptyState variant="neutral" size="xlarge" className={styles.emptyState}>
      <EmptyState.Icon>
        <TagIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>No tags yet</EmptyState.Heading>
      <EmptyState.Description className={styles.emptyStateDescription}>
        {canManageTags && hasCreatePermission ? (
          <>
            Create tags to organize and categorize your social media content.
            Tags help you track campaigns and analyze performance across your
            posts.
          </>
        ) : (
          <>
            Tags help organize and categorize social media content. Your team
            admin can create tags to help track campaigns and analyze
            performance across posts.
          </>
        )}
      </EmptyState.Description>
      {canManageTags && hasCreatePermission && (
        <EmptyState.Actions>
          <Button onClick={onCreateClick}>
            {!isMobile && <PlusIcon />}
            New Tag
          </Button>
        </EmptyState.Actions>
      )}
    </EmptyState>
  )
}
